import constate from 'constate';
import { useReducer } from 'react';
import createReducer from 'helpers/reducers-helper';
import assign from 'lodash/assign';
import get from 'lodash/get';
import { saveMe } from 'service/local-data-provider';
import { errorHandler } from 'helpers/error-handler';
import repo from 'service/repository';

export const INIT_APP_DONE = 'init_app_done';
export const UPDATE_USER_INFO = 'update_user_info';
export const UPDATE_BOOTSTRAPS = 'update_bootstraps';
export const UPDATE_LICENSE_PLATE = 'update_license_plate';
export const UPDATE_PARKING_RECORD = 'update_parking_record';
export const UPDATE_MAIN_PAGE_INIT_DATA = 'UPDATE_MAIN_PAGE_INIT_DATA';
export const SHOW_APP_MESSAGE = 'show_app_message';
export const HIDE_APP_MESSAGE = 'hide_app_message';
export const SHOW_TOAST_MESSAGE = 'show_toast_message';
export const NOW_SETTING_CREDIT_CARD = 'NOW_SETTING_CREDIT_CARD';
export const NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD = 'NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD';
export const NOW_SETTING_LICENSE_PLATE = 'NOW_SETTING_LICENSE_PLATE';
export const SET_CUSTOMER_SERVICE_DIALOG = 'SET_CUSTOMER_SERVICE_DIALOG';
export const SET_IS_SHOW_MARKETING_EMAIL_OPTED_IN_DIALOG = 'SET_IS_SHOW_MARKETING_EMAIL_OPTED_IN_DIALOG';
export const SET_LINE_BANK_LOGIN_DIALOG = 'SET_LINE_BANK_LOGIN_DIALOG';
export const BINDING_IS_SETTED = 'BINDING_IS_SETTED';
export const MAIN_PAGE_IS_SETTED = 'MAIN_PAGE_IS_SETTED';
export const LICENSE_PLATES_IS_SETTED = 'LICENSE_PLATES_IS_SETTED';
export const RESET = 'RESET';
export const REFUELING_REQUEST = 'REFUELING_REQUEST';
export const TOGGLE_REFUELING_PROCESSING_DIALOG = 'TOGGLE_REFUELING_PROCESSING_DIALOG';
export const SET_SCAN_COUNTDOWN = 'SET_SCAN_COUNTDOWN';
export const SET_SCAN_RESULT = 'SET_SCAN_RESULT';

const useApp = () => {
  const initState = {
    me: null,
    licensePlates: [],
    pending: true,
    bootstraps: null,
    appMessage: null,
    parkingRecord: [],
    oilPricing: null,
    mainPagePromotionBoard: [],
    mainPageNotificationBoard: [],
    orders: {
      refueling: [],
      parking: [],
    },
    toastMessage: null,
    customerServiceDialog: false,
    lineBankLoginDialog: false,
    nowSettingCreditCard: false,
    nowSettingLicensePlateAndCreditCard: false,
    nowSettingLicensePlate: false,
    setFrom: '',
    bindingIsSetted: false,
    mainPageIsSetted: false,
    licensePlatesIsSetted: false,
    refuelingRequest: null,
    isRefuelingRequestProcessing: false,
    promotionBoard: [],
    scanCountdown: false,
    scanResult: null,
    isShowMarketingEmailOptedInDialog: false
  };

  const initAppDone = (state, payload = {}) => {
    const me = get(payload, 'me', null);
    const licensePlates = get(payload, 'licensePlates', []);
    const parkingRecord = get(payload, 'parkingRecord', []);
    const promotionBoard = get(payload, 'promotionBoard', null);
    const orders = get(payload, 'orders', null);
    let refuelingOrders = orders?.refueling ?? [];
    let parkingOrders = orders?.parking ?? [];
    saveMe(me);
    return assign({}, state, {
      pending: false,
      me,
      licensePlates,
      parkingRecord,
      promotionBoard,
      bindingIsSetted: false,
      orders: {
        refueling: [...state.orders.refueling, ...refuelingOrders],
        parking: [...state.orders.parking, ...parkingOrders],
      },
    });
  };
  const updateBootstraps = (state, payload) => assign({}, state, { bootstraps: payload });
  const updateUserInfo = (state, payload) => {
    saveMe(payload);
    return assign({}, state, { me: payload });
  };
  const updateLicensePlate = (state, payload) => assign({}, state, { licensePlates: payload });
  const updateParkingRecord = (state, payload) => assign({}, state, { parkingRecord: payload });
  const updateMainPageInitData = (state, payload) =>
    assign({}, state, {
      mainPagePromotionBoard: payload[0],
      oilPricing: payload[1],
      mainPageNotificationBoard: payload[2],
      mainPageIsSetted: true,
    });
  const showAppMessage = (state, appMessage) => assign({}, state, { appMessage });
  const setIsShowMarketingEmailOptedInDialog = (state, isShowMarketingEmailOptedInDialog) => assign({}, state, { isShowMarketingEmailOptedInDialog });
  const hideAppMessage = state => assign({}, state, { appMessage: null });
  const showToastMessage = (state, payload) => assign({}, state, { toastMessage: payload });
  const nowSettingLicensePlateAndCreditCard = (state, payload) =>
    assign({}, state, { nowSettingLicensePlateAndCreditCard: payload.noPlateNoCard, setFrom: payload.from });
  const nowSettingCreditCard = (state, payload) =>
    assign({}, state, { nowSettingCreditCard: payload.noCard, setFrom: payload.from });
  const nowSettingLicensePlate = (state, payload) =>
    assign({}, state, { nowSettingLicensePlate: payload.noPlate, setFrom: payload.from });
  const setCustomerServiceDialog = (state, payload = true) => assign({}, state, { customerServiceDialog: payload });
  const setLineBankLoginDialog = (state, payload = true) => assign({}, state, { lineBankLoginDialog: payload });
  const bindingIsSetted = state => assign({}, state, { bindingIsSetted: true });
  const mainPageIsSetted = state => assign({}, state, { mainPageIsSetted: true });
  const licensePlatesIsSetted = state => assign({}, state, { licensePlatesIsSetted: true });
  const reset = () => initState;
  const setScanCountdown = (state, payload) => assign({}, state, { scanCountdown: payload });
  const setScanResult = (state, payload) => assign({}, state, { scanResult: payload });

  const reducer = createReducer(
    {
      [INIT_APP_DONE]: initAppDone,
      [UPDATE_USER_INFO]: updateUserInfo,
      [UPDATE_BOOTSTRAPS]: updateBootstraps,
      [UPDATE_LICENSE_PLATE]: updateLicensePlate,
      [UPDATE_PARKING_RECORD]: updateParkingRecord,
      [UPDATE_MAIN_PAGE_INIT_DATA]: updateMainPageInitData,
      [SHOW_APP_MESSAGE]: showAppMessage,
      [HIDE_APP_MESSAGE]: hideAppMessage,
      [SHOW_TOAST_MESSAGE]: showToastMessage,
      [NOW_SETTING_CREDIT_CARD]: nowSettingCreditCard,
      [NOW_SETTING_LICENSE_PLATE_AND_CREDIT_CARD]: nowSettingLicensePlateAndCreditCard,
      [NOW_SETTING_LICENSE_PLATE]: nowSettingLicensePlate,
      [SET_CUSTOMER_SERVICE_DIALOG]: setCustomerServiceDialog,
      [SET_IS_SHOW_MARKETING_EMAIL_OPTED_IN_DIALOG]: setIsShowMarketingEmailOptedInDialog,
      [SET_LINE_BANK_LOGIN_DIALOG]: setLineBankLoginDialog,
      [BINDING_IS_SETTED]: bindingIsSetted,
      [MAIN_PAGE_IS_SETTED]: mainPageIsSetted,
      [LICENSE_PLATES_IS_SETTED]: licensePlatesIsSetted,
      [RESET]: reset,
      [REFUELING_REQUEST]: (state, payload) => assign({}, state, { refuelingRequest: payload }),
      [TOGGLE_REFUELING_PROCESSING_DIALOG]: (state, payload) =>
        assign({}, state, { isRefuelingRequestProcessing: payload }),
      [SET_SCAN_COUNTDOWN]: setScanCountdown,
      [SET_SCAN_RESULT]: setScanResult,
    },
    initState,
    true
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const fetchParkingRecords = () => {
    return repo
      .fetchParkingRecord()
      .then(value => {
        dispatch({
          type: UPDATE_PARKING_RECORD,
          payload: value,
        });
      })
      .catch(error => showFailMessage(error));
  };

  const fetchMainPageData = () => {
    return Promise.all([
      repo.fetchMainPagePromotionBoard(),
      repo.fetchOilPricing(),
      repo.fetchMainPageNotificationBoard(),
    ])
      .then(value => {
        dispatch({
          type: UPDATE_MAIN_PAGE_INIT_DATA,
          payload: value,
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: MAIN_PAGE_IS_SETTED,
        });
      });
  };

  const showSuccessMessage = (message, onAppMessageDismiss) => {
    dispatch({
      type: SHOW_APP_MESSAGE,
      payload: {
        type: 'success',
        message,
        onAppMessageDismiss,
      },
    });
  };

  const showMarketingEmailOptedInDialog = () => {
    dispatch({
      type: SET_IS_SHOW_MARKETING_EMAIL_OPTED_IN_DIALOG,
      payload: true,
    });
  }
  
  const hideMarketingEmailOptedInDialog = () => {
    dispatch({
      type: SET_IS_SHOW_MARKETING_EMAIL_OPTED_IN_DIALOG,
      payload: false,
    });
  }

  const showFailMessage = error => {
    dispatch({
      type: SHOW_APP_MESSAGE,
      payload: {
        type: 'failure',
        message: errorHandler(error),
      },
    });
  };


  return {
    state,
    dispatch,
    showSuccessMessage,
    showFailMessage,
    fetchParkingRecords,
    fetchMainPageData,
    showMarketingEmailOptedInDialog,
    hideMarketingEmailOptedInDialog,
  };
};

const [AppProvider, useAppContext] = constate(useApp);

export { AppProvider, useAppContext };
